import { useQuery } from "@tanstack/react-query";

import { ADMIN_LEADS_ENDPOINTS, AdminLeadsService } from "@/service/api/admin-leads";

interface UseLeadDetailsParams {
  id: string;
  enabled?: boolean;
}

const useLeadDetails = ({ id, enabled }: UseLeadDetailsParams) =>
  useQuery({
    queryKey: [ADMIN_LEADS_ENDPOINTS.DETAIL(id)],
    queryFn: () => AdminLeadsService.get(id),
    enabled,
  });

export default useLeadDetails;
